module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('h1', {
    staticClass: "center"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc2",
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_vm._v("Newly Revised Stories")]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P3"
    }
  }, [_vm._v("SISTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A MARTIAN RICORSO")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCHRÖDINGER’S PLAGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BLOOD MUSIC")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SILICON TIMES E-BOOK REVIEW")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WARM SEA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TANGENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THROUGH ROAD NO WHITHER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DEAD RUN")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE WHITE HORSE CHILD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WEBSTER")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE VISITATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RICHIE BY THE SEA")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SLEEPSIDE STORY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_vm._v("Screenplay")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/JustOvertheHorizon_1P17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GENIUS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0348df20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JustOvertheHorizon_1P2.vue
// module id = 66
// module chunks = 0